import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExpenseType } from '../models/expense-type.model';
import { CreateExpenseTypeDto } from '../models/dtos/createExpenseType.dto';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExpenseTypeService {
  private readonly baseUrl = `${environment.base_url}/expensetypes`;

  constructor(private http: HttpClient) {}

  list(search: string = '', active?: boolean, page: number = 1): Observable<any> {
    let params: any = {};
    if (search) params.search = search;
    if (active !== undefined) params.active = active;
    if (page) params.page = page;
    return this.http.get(`${this.baseUrl}/list`, { params });
  }

  getActive(): Observable<any> {
    return this.http.get(`${this.baseUrl}/active`);
  }

  getAll(): Observable<any> {
    return this.http.get(`${this.baseUrl}`);
  }

  find(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/find/${id}`);
  }

  create(dto: CreateExpenseTypeDto): Observable<any> {
    return this.http.post(`${this.baseUrl}/create`, dto);
  }

  update(id: number, expenseType: ExpenseType): Observable<any> {
    return this.http.put(`${this.baseUrl}/update/${id}`, expenseType);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/delete/${id}`);
  }
} 